import { render } from "./ChartConfiguration.vue?vue&type=template&id=5231f20a"
import script from "./ChartConfiguration.vue?vue&type=script&lang=js"
export * from "./ChartConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/chart-building/ChartConfiguration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5231f20a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5231f20a', __exports__)) {
    api.reload('5231f20a', __exports__)
  }
  
  module.hot.accept("./ChartConfiguration.vue?vue&type=template&id=5231f20a", () => {
    api.rerender('5231f20a', render)
  })

}


export default __exports__